import React, { useState } from 'react';
import ObservabilityDashboard from '../components/ObservabilityDashboard';

const ObservabilityPage: React.FC = () => {
  const [selectedWorkflowType, setSelectedWorkflowType] = useState<string>('');

  const workflowTypes = [
    { value: '', label: 'All Workflows' },
    { value: 'data-processing', label: 'Data Processing' },
    { value: 'image-processing', label: 'Image Processing' },
    { value: 'notification', label: 'Notification' },
    { value: 'batch-job', label: 'Batch Job' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Observability</h1>
              <p className="mt-2 text-gray-600">
                Monitor workflow performance, reliability, and operational metrics
              </p>
            </div>
            
            <div className="flex items-center space-x-4">
              <select
                value={selectedWorkflowType}
                onChange={(e) => setSelectedWorkflowType(e.target.value)}
                className="border border-gray-300 rounded-md px-3 py-2 text-sm bg-white"
              >
                {workflowTypes.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Dashboard */}
        <ObservabilityDashboard selectedWorkflowType={selectedWorkflowType} />
      </div>
    </div>
  );
};

export default ObservabilityPage;
